// 账号相关api
import base from '~/api/base' // 导入域名配置
import axios from '~/utils/axios' // 导入http中创建的axios实例
import qs from 'qs' // post、put、patch的json序列化工具
import store from '~/store/index'

const user = {

  // 获取自己的信息
  findMe() {
    return axios.get(`${base.host}/users/me`)
  },

  // 根据用户id获取信息
  findById(userId) {
    return axios.get(`${base.host}/users/${userId}`)
  },

  // 搜索用户
  findAll({ nickname, page }) {
    return axios.get(`${base.host}/users`, {
      params: { nickname, page }
    })
  },

  // 更改自己的信息
  update(params) {
    return axios.put(`${base.host}/users/me`, qs.stringify(params))
  },

  // 站长删除用户
  delete(userId) {
    return axios.delete(`${base.host}/users/${userId}`)
  },

  // 站长修改用户类型
  updateUserType(userId, { type }) {
    return axios.put(`${base.host}/users/${userId}`, qs.stringify({ type }))
  },

  // 注册正常用户
  registerNormal({ nickname, email, password }) {
    return new Promise((resolve, reject) => {
      axios.post(`${base.host}/users/register`, qs.stringify({ nickname, email, password })).then(res => {
        const token = res.data.token
        if (token) {
          store.commit('globalData/updateToken', token)
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 注册开发者
  registerDeveloper({ nickname, email, password, invitationCode }) {
    return new Promise((resolve, reject) => {
      axios.post(`${base.host}/users/register`, qs.stringify({ nickname, email, password }), { params: { invitationCode }}).then(res => {
        const token = res.data.token
        if (token) {
          window.localStorage.setItem('token', token)
          store.commit('globalData/updateToken', token)
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 登录, 保存token到localstorage和vuex
  login({ email, password }) {
    return new Promise((resolve, reject) => {
      axios.post(`${base.host}/users/login`, qs.stringify({ email, password })).then(res => {
        const token = res.data.token
        if (token) {
          window.localStorage.setItem('token', token)
          store.commit('globalData/updateToken', token)
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  // 发送修改密码邮件
  sendUpdatePasswordEmail({ email }) {
    return axios.post(`${base.host}/users/sendUpdatePasswordEmail`, qs.stringify({ email }))
  },

  // 修改自己的密码
  updatePassword({ password }) {
    return axios.put(`${base.host}/users/password`, qs.stringify({ password }))
  }
}

export default user
